import { jsx } from "react/jsx-runtime";
import { Overlay } from "../Overlay/Overlay.mjs";
const boxShadowForVariant = {
  default: "borderField",
  disabled: "borderNeutralLight",
  focus: "outlineFocus",
  hover: "borderFormAccent",
  critical: "borderCritical"
};
const FieldOverlay = ({ variant, ...restProps }) => /* @__PURE__ */ jsx(
  Overlay,
  {
    component: "span",
    borderRadius: "small",
    boxShadow: boxShadowForVariant[variant],
    transition: "fast",
    ...restProps
  }
);
export {
  FieldOverlay
};
